import React, { useState, useEffect } from "react";

const CardStatContractTotal = ({ totalCurrent, totalLast }) => {
  useEffect(() => {
    return () => {};
  }, [totalCurrent, totalLast]);

  return (
    <div className="">
      <span className="h6 text-dark mr-1">{totalCurrent}</span>
      <span
        className={
          totalCurrent - totalLast >= 0 ? "H5 text-primary" : "H5 text-danger"
        }
      >
        ({totalCurrent - totalLast} /{" "}
        {totalLast > 0
          ? Math.ceil(((totalCurrent - totalLast) / totalLast) * 100)
          : 0}
        %)
      </span>
    </div>
  );
};

const CardStatContract = ({
  id,
  type,
  title,
  totalCurrent,
  totalLast,
  totalNa,
  bSelectable = false,
  bSelected,
  onSelect,
}) => {
  const [terminateRate, setTerminateRate] = useState(false);
  useEffect(() => {
    if (totalCurrent + totalNa > 0) {
      setTerminateRate(Math.ceil((totalNa / (totalCurrent + totalNa)) * 100));
    } else {
      setTerminateRate(0);
    }
    return () => {};
  }, [
    title,
    totalCurrent,
    totalLast,
    totalNa,
    bSelectable,
    bSelected,
    terminateRate,
  ]);

  return (
    <div className="w-100" onClick={() => (onSelect ? onSelect(id, type) : "")}>
      <div
        className={
          bSelectable
            ? `card border-top app-stat mb-1`
            : "card border-top mb-1"
        }
      >
        <div className={`card-header app-stat pt-1 mb-0 ${type ? "bg-summary-union-70" : ""} ${bSelectable && bSelected ? "bg-warning app-stat-selected" : "app-stat-not-selected"}`} style={{ padding: "5px 10px" }}>
          <h4>{title}</h4>
        </div>
        <div
          className="card-body metric-value"
          style={{ padding: "7px 5px" }}
        >
          <div className="d-flex flex-row-reverse mb-2">
            <CardStatContractTotal
              totalCurrent={totalCurrent}
              totalLast={totalLast}
            />
          </div>
          <div className="border-top">
            <div className="row mb-0">
              <h5 className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-muted font-12 mb-0">
                {totalCurrent}
              </h5>
              <h5
                className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-muted font-12 mb-0"
                style={{ textAlign: "right" }}
              >
                {totalNa}
              </h5>
            </div>
          </div>
          <div className="progress progress-lg">
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: 100 - terminateRate + "%" }}
              aria-valuenow="25"
              aria-valuemin="05"
              aria-valuemax="100"
            >
              {100 - terminateRate}%
            </div>
            <div
              className="progress-bar bg-danger"
              role="progressbar"
              style={{ width: terminateRate + "%" }}
              aria-valuenow="25"
              aria-valuemin="5"
              aria-valuemax="100"
            >
              {terminateRate}%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardStatContract;
